import React from 'react';
import Navbar from '../components/Navbar';
import Breadcrumb from '../components/Breadcrumb';
import ContentSplitSections from '../components/ContentSplitSections';
import { Link } from 'react-router-dom';
import '../styles/light.css';
import CTASection from '../components/CTASection';

// Holiday lighting service sections
const residentialLighting = [
  {
    title: "Residential Holiday Magic",
    text: `Transform Your Home into a Winter Wonderland\n\nFrom elegant white lights outlining your roofline to festive multicolor displays, we create custom holiday lighting designs that bring joy to your family and neighborhood. Our professional-grade LED lights provide brilliant illumination while saving energy.\n\nPopular Options:\n• Roofline and gutter lighting\n• Window and door accents\n• Walkway and driveway illumination\n• Garage and architectural features\n• Custom color schemes to match your style`,
    image: "/images/lights/holidayAngle.png",
    alt: "Residential Holiday Lighting",
    reverse: false
  },
  {
    title: "Tree & Shrub Illumination",
    text: `Bring Your Landscape to Life\n\nOur expert installers carefully wrap trees and shrubs to create stunning outdoor displays. Choose from branch wrapping for maximum sparkle or spiral wrapping for elegant simplicity. We work with your landscape's natural beauty to enhance, not overwhelm.\n\nLighting Techniques:\n• Branch wrap for deciduous trees\n• Spiral wrap for evergreens\n• Shrub and bush highlighting\n• Trunk wrapping for dramatic effect\n• Mixed techniques for visual interest`,
    image: "/images/lights/coverTrees.jpeg",
    alt: "Tree and Shrub Lighting",
    reverse: true
  },
  // {
  //   title: "Commercial & Business Displays",
  //   text: `Attract Customers with Professional Holiday Lighting\n\nMake your business stand out during the holiday season with eye-catching displays that draw customers and create a festive atmosphere. We work with Sun Valley's resorts, restaurants, and retail establishments to create memorable holiday experiences.\n\nCommercial Services:\n• Storefront and entrance lighting\n• Large-scale tree installations\n• Custom signage illumination\n• Parking area and walkway safety lighting\n• Scheduled timer systems`,
  //   image: "/images/placeholder-commercial-lighting.jpg",
  //   alt: "Commercial Holiday Lighting",
  //   reverse: false
  // }
];

// const specialtyServices = [
//   {
//     title: "Custom Design Services",
//     text: `Your Vision, Professionally Executed\n\nEvery property is unique, and your holiday lighting should be too. Our design team works with you to create custom lighting plans that complement your architecture and landscape while staying within budget.\n\nDesign Process:\n• On-site consultation and measurement\n• Custom design proposal with visuals\n• Color and style recommendations\n• Energy usage calculations\n• Professional installation timeline`,
//     image: "/images/lights/holidayDriveway.png",
//     alt: "Custom Holiday Lighting Design",
//     reverse: false
//   },
//   {
//     title: "Installation & Takedown",
//     text: `Hassle-Free Holiday Lighting\n\nSit back and enjoy the season while our professional crews handle everything. We install your lights safely and efficiently, then return after the holidays to carefully remove and store them for next year.\n\nOur Complete Service:\n• Professional installation by trained crews\n• All necessary equipment and hardware\n• Timer and control system setup\n• Post-holiday removal\n• Safe storage until next season`,
//     image: "/images/lights/holidayGaz.png",
//     alt: "Professional Installation",
//     reverse: true
//   }
// ];

const Light = () => {
  return (
    <div className="light-page">
      <Navbar />
      <Breadcrumb />
      
      {/* Hero Section */}
      <section className="light-hero">
        <img 
          src="/images/lights/lightHeroImage.png" 
          alt="Holiday Lighting Display" 
          className="hero-image"
          loading="eager"
          decoding="async"
        />
        <div className="hero-overlay"></div>
        <div className="hero-sparkles"></div>
        <div className="light-hero-content">
          <h1 className="light-hero-title">Professional Holiday Lighting</h1>
          <p className="hero-subtitle">
            Transform your Sun Valley property into a magical winter wonderland with All Seasons' inspiring holiday lighting displays
          </p>
          <Link to="mailto:info@allseasons.info">
                              <button
                                className="btn-cta"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textTransform: "uppercase" }}
                              >
                        Request A Consultation
                         </button>
                      </Link>
        </div>
      </section>

      {/* Introduction */}
      <section className="section bg-white">
        <div className="section-inner text-center">
          <h2 className="section-title">Sun Valley's Premier Residential and Commercial Holiday Lighting Experts</h2>
          <p className="intro-text">
            All Seasons Landscaping is known far and wide for its inspiring holiday lighting displays! 
            We will install holiday lighting on your exterior facades, trees, shrubs, walls, barns, 
            sheds and fence lines. We can branch wrap the trees or spiral wrap. We have a wide range 
            of colors to choose from in energy-saving LED lights. We also do repairs to existing lights.
          </p>
        </div>
      </section>
      
      <ContentSplitSections sections={residentialLighting} />
      <section className="section bg-white">
        <div className="section-inner">
        </div>
      </section>
      
      {/* <ContentSplitSections sections={specialtyServices} /> */}

      {/* Gallery Section */}
      {/* <section className="section bg-soft-snow">
        <div className="section-inner">
          <h2 className="section-title text-center">Holiday Lighting Gallery</h2>
          <p className="section-intro">See the magic we've created throughout Sun Valley</p>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img src="/images/lights/holidayOutline.png" alt="Holiday Lighting Display 1" />
            </div>
            <div className="gallery-item">
              <img src="/images/lights/holidayDriveway.png" alt="Holiday Lighting Display 2" />
            </div>
            <div className="gallery-item">
              <img src="/images/lights/lights5.jpg" alt="Holiday Lighting Display 3" />
            </div>
            <div className="gallery-item">
              <img src="/images/lights/lightHeroImage.png" alt="Holiday Lighting Display 4" />
            </div>
            <div className="gallery-item">
              <img src="/images/lights/holidayTrees.png" alt="Holiday Lighting Display 5" />
            </div>
            <div className="gallery-item">
              <img src="/images/lights/holidayStar.png" alt="Holiday Lighting Display 6" />
            </div>
            <div className="gallery-item">
              <img src="/images/lights/holidayGaz.png" alt="Holiday Lighting Display 7" />
            </div>
            <div className="gallery-item">
              <img src="/images/lights/holidayGreenTrees.png" alt="Holiday Lighting Display 8" />
            </div>
          </div>
        </div>
      </section> */}

      {/* Process Section */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Our Holiday Lighting Process</h2>
          <div className="light-process-timeline">
            <div className="light-timeline-container">
              <div className="light-timeline-item">
                <div className="light-timeline-number">1</div>
                <div className="light-timeline-content">
                  <h3>Early Planning</h3>
                  <p>Schedule your consultation in early fall to ensure availability and best selection</p>
                </div>
              </div>
              <div className="light-timeline-item">
                <div className="light-timeline-number">2</div>
                <div className="light-timeline-content">
                  <h3>Custom Design</h3>
                  <p>We create a lighting plan tailored to your property and preferences</p>
                </div>
              </div>
              <div className="light-timeline-item">
                <div className="light-timeline-number">3</div>
                <div className="light-timeline-content">
                  <h3>Professional Installation</h3>
                  <p>Our crews install your display safely and efficiently before Thanksgiving</p>
                </div>
              </div>
              <div className="light-timeline-item">
                <div className="light-timeline-number">4</div>
                <div className="light-timeline-content">
                  <h3>Season-Long Support</h3>
                  <p>We provide maintenance and repairs throughout the holiday season</p>
                </div>
              </div>
              <div className="light-timeline-item">
                <div className="light-timeline-number">5</div>
                <div className="light-timeline-content">
                  <h3>Careful Removal</h3>
                  <p>After the holidays, we remove and store your lights for next year</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

        {/* CTA Section */}
     <CTASection 
  title="Ready to Light Up Your Holidays?"
  subtitle="Don't wait! Our holiday lighting calendar fills up quickly. 
            Schedule your consultation today to ensure your property shines this season."
  galleryLink="/Gallery/treefarm"
  showEmergency={false}
/>
    </div>
  );
};

export default Light;